import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useForm } from "react-hook-form";
import bombicon from "../Image/lockerBomb.png";
import daimondicon from "../Image/lockerMoney.png";
import locker from "../Image/locker.png";
import bitcoin from "../Image/bitcoin.png";
import winner from "../Image/gameWinImg.png";
import looser from "../Image/gameLoseImg.png";
import { toast } from "react-toastify";

function Minegame({ setOpenLogin, isAuth }) {
  const [tableData, setTableData] = useState([]);
  const [cells, setCells] = useState(Array(25).fill(false));
  const [minePositions, setMinePositions] = useState([]);
  const [gameOver, setGameOver] = useState(false);
  const [gameStart, setGameStart] = useState(false);
  const [gameResult, setGameResult] = useState(null);
  const [openedCount, setOpenedCount] = useState(0);

  const { wallet, setWallet } = useAuth();

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("MinegameData")) || [];

    setTableData(storedData);

    const loadWallet = () => {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

      setWallet(currentUser?.wallet ? parseFloat(currentUser.wallet) : 0);
    };

    loadWallet();
  }, [isAuth, setWallet]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const generateMines = (mineCount) => {
    let mines = [];

    while (mines.length < mineCount) {
      let random = Math.floor(Math.random() * 25);

      if (!mines.includes(random)) {
        mines.push(random);
      }
    }

    return mines;
  };

  const updateWalletAndGame = (result, amount, currentUser) => {
    let finalWallet =
      result === "winner" ? wallet + amount * 2 : wallet - amount;

    setWallet(finalWallet);

    currentUser.wallet = finalWallet;

    localStorage.setItem("currentUser", JSON.stringify(currentUser));

    const users = JSON.parse(localStorage.getItem("user")) || [];

    const updatedUsers = users.map((user) => {
      if (user.email === currentUser.email) {
        return {
          ...user,
          wallet: finalWallet,
        };
      }

      return user;
    });

    localStorage.setItem("user", JSON.stringify(updatedUsers));

    const newGameData = {
      email: currentUser?.email || "Guest",
      mine: minePositions.length,
      amount,
      winAmount: result === "winner" ? amount * 2 : 0,
      gameResult: result,
    };

    setTableData((prev) => {
      const updatedData = [...prev, newGameData];

      localStorage.setItem("MinegameData", JSON.stringify(updatedData));

      return updatedData;
    });
  };

  const finishGame = (result, amount, currentUser) => {
    setGameOver(true);

    setGameResult(result);

    if (result === "looser") {
      setCells(Array(25).fill(true));
    }

    updateWalletAndGame(result, amount, currentUser);

    setTimeout(() => {
      setCells(Array(25).fill(false));
      setGameStart(false);
      setGameOver(false);
      setGameResult(null);
      setOpenedCount(0);
      reset();
    }, 3000);
  };

  const checkGameResult = (isWinner, amount, currentUser) => {
    finishGame(isWinner ? "winner" : "looser", amount, currentUser);
  };

  const handleClick = (index) => {
    if (!gameStart || gameOver || cells[index]) return;

    let newCells = [...cells];

    newCells[index] = true;

    setCells(newCells);

    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};

    const amount = Number(document.querySelector(".amount-input").value);

    if (minePositions.includes(index)) {
      checkGameResult(false, amount, currentUser);

      return;
    }

    const totalOpened = openedCount + 1;

    setOpenedCount(totalOpened);

    if (totalOpened === 25 - minePositions.length) {
      checkGameResult(true, amount, currentUser);
    }
  };

  const onSubmit = (data) => {
    if (!isAuth) {
      setOpenLogin(true);
      return;
    }

    if (Number(data.amount) > wallet) {
      toast.error("Insufficient Wallet Balance");
      return;
    }

    setGameStart(true);

    setCells(Array(25).fill(false));

    setGameOver(false);

    setGameResult(null);

    setOpenedCount(0);

    const randomMines = generateMines(Number(data.mine));

    console.log("Mine Positions:", randomMines);

    setMinePositions(randomMines);
  };

  return (
    <div className="minegame-section">
      <div className="container">
        <div className="minegame-wrapper">
          {gameResult && (
            <div className="result-popup">
              <img
                src={gameResult === "winner" ? winner : looser}
                alt={gameResult}
                className="result-status-img"
              />

              <button onClick={() => setGameResult(null)}>Close</button>
            </div>
          )}

          <div className="minegame-wrapper-inner">
            <form onSubmit={handleSubmit(onSubmit)} className="minegame-card">
              <select
                className="input-box"
                {...register("mine", {
                  required: "Select Mine",
                })}
              >
                <option value="">Select Mines:</option>

                {[...Array(20)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>

              {errors.mine && <p className="error">{errors.mine.message}</p>}

              <div className="input-box d-flex gap-2">
                <div className="d-flex align-items-center">
                  <img src={bitcoin} alt="bitcoin" height={24} />
                </div>

                <input
                  type="number"
                  step="any"
                  placeholder="Enter Bet Amount"
                  className="amount-input"
                  {...register("amount", {
                    required: "Amount is required",
                    validate: (value) =>
                      parseFloat(value) > 0 || "Amount must be greater than 0",
                  })}
                />
              </div>

              {errors.amount && (
                <p className="error">{errors.amount.message}</p>
              )}

              <button
                type="submit"
                className="bet-btn"
                onClick={() => {
                  if (!isAuth) {
                    setOpenLogin(true);
                  }
                }}
              >
                BET
              </button>
            </form>
          </div>

          <div style={{ textAlign: "center" }}>
            <div className="game-box">
              {cells.map((cell, i) => (
                <div
                  key={i}
                  onClick={() => handleClick(i)}
                  className="gamebox-inner"
                >
                  {cell ? (
                    minePositions.includes(i) ? (
                      <img src={bombicon} alt="bomb" />
                    ) : (
                      <img src={daimondicon} alt="diamond" />
                    )
                  ) : (
                    <img src={locker} alt="locker" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="gametable-responsive-wrapper">
          <table className="game-table mt-3">
            <thead
              style={{
                backgroundColor: "#0E2650",
              }}
            >
              <tr>
                <th>Player Email</th>
                <th>Mines</th>
                <th>Bet Amount</th>
                <th>Win Amount</th>
                <th>Result</th>
              </tr>
            </thead>

            <tbody
              style={{
                backgroundColor: "#224c96",
              }}
            >
              {tableData.length > 0 ? (
                tableData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.email}</td>
                    <td>{item.mine}</td>
                    <td>{item.amount}</td>
                    <td>{item.winAmount ? item.winAmount : "-"}</td>
                    <td>{item.gameResult}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center" }}>
                    No Game Played Yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Minegame;
